import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const WA_GENERIC = 'https://api.whatsapp.com/send/?phone=5562994767293&text&type=phone_number&app_absent=0';

const navLinks = [
  { label: 'Serviços', href: '#servicos' },
  { label: 'Como Funciona', href: '#como-funciona' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Planos', href: '#planos' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? 'nav-blur bg-white/90 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a
          href="#hero"
          data-testid="logo-link"
          onClick={(e) => handleClick(e, '#hero')}
          className="flex items-center"
        >
          <span
            className="text-2xl md:text-3xl font-bold"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-2px' }}
          >
            <span style={{ color: scrolled ? '#0A2540' : '#FFFFFF' }}>Fin</span>
            <span style={{ color: '#10B981' }}>Contex</span>
          </span>
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-${link.href.slice(1)}`}
              onClick={(e) => handleClick(e, link.href)}
              className={`text-sm font-medium tracking-wide transition-colors hover:text-[#10B981] ${
                scrolled ? 'text-[#0A2540]' : 'text-white/90'
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href={WA_GENERIC}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-button"
            className="bg-[#10B981] text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#059669] transition-colors"
          >
            Fale com um contador
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? (
            <X size={24} className={scrolled ? 'text-[#0A2540]' : 'text-white'} />
          ) : (
            <Menu size={24} className={scrolled ? 'text-[#0A2540]' : 'text-white'} />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-slate-100 shadow-lg"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`mobile-nav-${link.href.slice(1)}`}
                onClick={(e) => handleClick(e, link.href)}
                className="text-[#0A2540] text-base font-medium py-2 hover:text-[#10B981] transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href={WA_GENERIC}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-cta-button"
              className="bg-[#10B981] text-white px-6 py-3 rounded-lg text-center text-sm font-semibold hover:bg-[#059669] transition-colors mt-2"
            >
              Fale com um contador
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
